import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Avatar, Box, Tooltip, TablePagination, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageIcon from '@mui/icons-material/Image';

function ItemTable({ items = [], onEditItem, onDeleteItem }) {
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [dialogImages, setDialogImages] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleImageClick = (imgArr) => {
    setDialogImages(imgArr);
    setOpenImageDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenImageDialog(false);
    setDialogImages([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedItems = items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      <TableContainer component={Paper} sx={{ borderRadius: 2, background: '#ffffff', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #e8edf5', width: '100%', mx: 'auto' }}>
        <Box sx={{ px: 2, pt: 2 }}>
          <TablePagination
            component="div"
            count={items.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25, 50]}
            sx={{ background: '#ffffff', borderRadius: 2, fontWeight: 500 }}
          />
        </Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>SKU</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Item Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Description</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>MRP</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Selling Price</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Stock</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Image</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Additional Images</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', color: '#1a3c6e' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedItems && paginatedItems.length > 0 ? paginatedItems.map((item, idx) => (
              <TableRow key={item.sku}>
                <TableCell>{item.sku}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <Tooltip title={item.description || ''} arrow placement="top">
                    <span>
                      {item.description && item.description.length > 30
                        ? item.description.slice(0, 30) + '...'
                        : item.description}
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell>{item.category}</TableCell>
                <TableCell>{item.mrp}</TableCell>
                <TableCell>{item.sellingPrice}</TableCell>
                <TableCell>
                  {item.stock === 0 ? (
                    <Chip label="Out of Stock" color="error" size="small" sx={{ fontWeight: 400, fontSize: 13, letterSpacing: 0.5 }} />
                  ) : (
                    item.stock
                  )}
                </TableCell>
                <TableCell>
                  <IconButton onClick={() => handleImageClick([item.image])} size="small">
                    <ImageIcon sx={{ color: '#1a3c6e', fontSize: 28 }} />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <IconButton onClick={() => handleImageClick(item.additionalImages.split(","))} size="small">
                      <ImageIcon sx={{ color: '#1a3c6e', fontSize: 28 }} />
                    </IconButton>
                  </Box>
                </TableCell>
                <TableCell align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                    <IconButton size="small" sx={{ color: '#1a3c6e' }} onClick={() => onEditItem && onEditItem(item)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" size="small" onClick={() => onDeleteItem && onDeleteItem(item.sku)}>
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell colSpan={10} align="center">No items found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* Image Dialog */}
      {openImageDialog && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleCloseDialog}
        >
          <Box sx={{ display: 'flex', gap: 2, p: 2, bgcolor: '#ffffff', borderRadius: 3, boxShadow: '0 4px 24px rgba(0,0,0,0.18)', border: '1px solid #e8edf5' }} onClick={e => e.stopPropagation()}>
            {dialogImages.map((img, i) => (
              <Avatar key={i} src={img} variant="rounded" sx={{ width: 180, height: 180, border: '2px solid #1a3c6e' }} />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
}

export default ItemTable;
